const sortListStringNum = (arr) => {
    return arr.map(Number).sort((a, b) => a - b)
}

export default sortListStringNum;